import React from "react";
import { Box, Grid, GridSize, Typography } from "@mui/material";
import {
  ItemIconBox,
  MemberInfoField,
  PatientDetailsValue,
  patientNameContainer,
  patientNameTypo,
  styles,
} from "../style";
import fontWeight from "../../../styles/mui/fontWeight";
import colors from "../../../styles/colors/colors";
import { displayFlex } from "../../../styles/mui/styles/display";
import { PatientHeaderFormProps } from ".";
import { formatDate } from "../../../utils/DateTime";
import { DateFormats } from "../../../constants/Date";

export const PatientNameGrid = (patientName: string) => {
  return (
    <Grid sx={styles.container}>
      <Typography
        variant="h2"
        fontWeight={fontWeight.Weight[7]}
        lineHeight={"1.8rem"}
        sx={patientNameTypo}
        color={colors.fonts[18]}
      >
        <Box style={styles.lineItem}>{patientName}</Box>
      </Typography>
    </Grid>
  );
};

const PrimarySubscriberInfo  = ({ getValues }: PatientHeaderFormProps) => {
  const fieldRender = (
    label: string,
    xs: GridSize,
    value: string | number | null,
    icon?: React.ReactNode
  ) => {
    return (
      <Grid size={xs} sx={MemberInfoField}>
        <Typography
          variant="body1"
          fontWeight={fontWeight.Weight[3]}
          color={colors.fonts[2]}
        >
          {label}
        </Typography>
        <Box sx={displayFlex}>
          {icon && value ? <Box sx={ItemIconBox}>{icon}</Box> : ""}
          <Typography
            variant="subtitle2"
            fontWeight={fontWeight.Weight[5]}
            color={colors.fonts[4]}
            sx={PatientDetailsValue}
          >
            {value}
          </Typography>
        </Box>
      </Grid>
    );
  };
  return (
    <Grid container wrap="nowrap" columnSpacing={0.5}>
      <Grid size="auto" sx={patientNameContainer}>
        {PatientNameGrid(getValues("patientName"))}
      </Grid>
      <Grid size="grow">
        <Grid container size={"grow"}>
          <Grid size={12}>
            <Grid container>
              {fieldRender(
                "Subscriber Last Name:",
                2,
                getValues("memberInfo.subscriberLastName")
              )}
              {fieldRender(
                "Subscriber First Name:",
                "auto",
                getValues("memberInfo.subscriberFirstName")
              )}
            </Grid>
          </Grid>
          <Grid size={12} pt={"1.5rem"} pb={"1.5rem"}>
            <Grid container>
              {fieldRender(
                "Subscriber Date of Birth:",
                2,
                formatDate(
                  getValues("memberInfo.subscriberDateOfBirth"),
                  DateFormats.MM_DD_YYYY
                )
              )}
              {fieldRender(
                "Subscriber Gender:",
                "auto",
                getValues("memberInfo.subscriberGender")
              )}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default PrimarySubscriberInfo;
